import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, Text } from "@mantine/core";
import { useAppAction } from "../../hooks/redux.js";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { useCallback } from "react";
import { Event } from "../../constants/events.js";
import { IconX } from "@tabler/icons-react";
import { selectSourceLayer, selectSourceLayerLayer } from "../../reducers/sourcesReducer.js";
export const SourceLayerConfigHeader = ({ sourceLayerId, layer, }) => {
    const captureEvent = useCaptureEvent();
    const changeSourceLayer = useAppAction(selectSourceLayer);
    const changeSourceLayerLayer = useAppAction(selectSourceLayerLayer);
    const handleClose = useCallback((event) => {
        event.stopPropagation();
        captureEvent(Event.CloseSourceLayerConfig);
        changeSourceLayer(null);
        changeSourceLayerLayer(null);
    }, [changeSourceLayer, changeSourceLayerLayer, captureEvent]);
    return (_jsxs(Group, { p: "xs", gap: "xs", h: "50px", align: "center", justify: "space-between", children: [_jsx(Text, { fw: 500, size: "sm", children: layer?.id ?? sourceLayerId }), _jsx(IconX, { onClick: handleClose })] }));
};
